module.exports = __webpack_public_path__ + "media/images/icons/projects-219465f813313c90cc81fc546a035a15.svg";